<!--发送组件-->
<template>
  <div class="submit-group">
    <div class="submit"
         :key="submitIndex"
         @click="clickSubmitCmp(submitIndex)"
         @drop="(event) => dragToSubmitCmp(event, submitItem, submitIndex)"
         @dragover="allowSignalMeasureDrop">
      <div class="cmp-handle">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-input__icon el-icon-more"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                @click.native="handleCmp('delete', submitItem, submitIndex)">删除
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <p style="font-size: 16px;font-weight: bold">{{ componentStyleInfoArray.submitCmp.title}}</p>
      <!--      修改发送组件的样式-->
      <!--        <a>-->
      <!--          <div class="submit-table-content" style="background-color: #3389e8">-->
      <!--            <template>-->
      <!--              <div>-->
      <!--                <el-table-->
      <!--                  :data="tableData"-->
      <!--                  style="width: 100%;margin-bottom: 20px;"-->
      <!--                  row-key="id"-->
      <!--                  border-->
      <!--                  default-expand-all-->
      <!--                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">-->
      <!--                  <el-table-column-->
      <!--                    prop="date"-->
      <!--                    label="日期"-->
      <!--                    sortable-->
      <!--                    width="180">-->
      <!--                  </el-table-column>-->
      <!--                  <el-table-column-->
      <!--                    prop="name"-->
      <!--                    label="姓名"-->
      <!--                    sortable-->
      <!--                    width="180">-->
      <!--                  </el-table-column>-->
      <!--                  <el-table-column-->
      <!--                    prop="address"-->
      <!--                    label="地址">-->
      <!--                  </el-table-column>-->
      <!--                </el-table>-->

      <!--                <el-table-->
      <!--                  :data="tableData1"-->
      <!--                  style="width: 100%"-->
      <!--                  row-key="id"-->
      <!--                  border-->
      <!--                  lazy-->
      <!--                  :load="load"-->
      <!--                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">-->
      <!--                  <el-table-column-->
      <!--                    prop="date"-->
      <!--                    label="日期"-->
      <!--                    width="180">-->
      <!--                  </el-table-column>-->
      <!--                  <el-table-column-->
      <!--                    prop="name"-->
      <!--                    label="姓名"-->
      <!--                    width="180">-->
      <!--                  </el-table-column>-->
      <!--                  <el-table-column-->
      <!--                    prop="address"-->
      <!--                    label="地址">-->
      <!--                  </el-table-column>-->
      <!--                </el-table>-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </a>-->
      <!--        <a>-->
      <!--          <div class="submit-table-content" style="background-color: #99a9bf">-->
      <!--            <template>-->
      <!--              <el-table-->
      <!--                :data="tableData"-->
      <!--                style="width: 100%">-->
      <!--                <el-table-column type="expand">-->
      <!--                  <template slot-scope="props">-->
      <!--                    <el-form label-position="left" inline class="demo-table-expand">-->
      <!--                      <el-form-item label="Id">-->
      <!--                        <span>{{ props.row.name }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="name">-->
      <!--                        <span>{{ props.row.shop }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="">-->
      <!--                        <span>{{ props.row.id }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="店铺 ID">-->
      <!--                        <span>{{ props.row.shopId }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="商品分类">-->
      <!--                        <span>{{ props.row.category }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="店铺地址">-->
      <!--                        <span>{{ props.row.address }}</span>-->
      <!--                      </el-form-item>-->
      <!--                      <el-form-item label="商品描述">-->
      <!--                        <span>{{ props.row.desc }}</span>-->
      <!--                      </el-form-item>-->
      <!--                    </el-form>-->
      <!--                  </template>-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="信号ID"-->
      <!--                  prop="id">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="信号名称"-->
      <!--                  prop="name">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="发送周期"-->
      <!--                  prop="desc">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="发送次数"-->
      <!--                  prop="desc">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="发送类型"-->
      <!--                  prop="desc">-->
      <!--                </el-table-column>-->
      <!--              </el-table>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </a>-->
      <!--      下面是原来的组件显示信息-->
      <span style="font-size: 14px">{{info}}</span>
      <a>
        <div class="title-content">
          <el-checkbox v-model="nohup" style="margin-top: 10px;font-weight: bold">循环
          </el-checkbox>
          <el-input-number v-model="times" controls-position="right" v-show="!nohup" :min="1"
                           style="margin-right: 20px;width: 150px" @change="handleSubmit(0)"></el-input-number>
          <el-input style="margin-right: 20px;width: 200px" v-model="cycle" @change="handleSubmit(0)"
                    placeholder="请输入发送周期">
            <template slot="append">ms</template>
            发送周期
          </el-input>
          <el-button type="primary" @click="handleSubmit(0)" style="float: right">发送</el-button>
          <el-button type="danger" size="mini" @click="stopSend" round>停止发送</el-button>
        </div>
      </a>
      <a>
        <div class="submit-table-content">
          <el-table
              :data="dragNodeData.children"
              border
              style="width: 100%">
            <el-table-column
                prop="text"
                label="名称"
                width="'50%'">
              <template slot-scope="scope">
              <span style="cursor: pointer"
                    :title="scope.row.id"
                    @dblclick="(event)=>dbClick(event,scope.row.id)">
                {{ scope.row.text }}
              </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="byteOrder"
                label="值"
                width="'50%'">
              <template slot-scope="scope">
                <el-input v-show="scope.row.enumSigs.length===0" v-model="scope.row.byteOrder"
                          @change="scope.row.byteOrder=inputCheck(scope.row.byteOrder+'',scope.row.max,scope.row.min),handleSubmit(1)"
                          @blur="scope.row.byteOrder=inputCheck(scope.row.byteOrder+'',scope.row.max,scope.row.min)"></el-input>
                <el-select v-show="scope.row.enumSigs.length!==0" v-model="scope.row.byteOrder" placeholder="请选择"
                           clearable style="width: 100%">
                  <el-option
                      v-for="(item,key) in scope.row.enumSigs"
                      :key="key"
                      :label="item.key"
                      :value="item.val">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </a>
      <!--      发送组件内存显示到此结束-->
    </div>
  </div>
</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import cloneDeep from 'lodash/fp/cloneDeep';

export default {
  name: 'submitCmp',
  props: {
    submitItem: {
      type: Object,
    },
    submitIndex: {
      default: 0,
      type: Number,
    },
    sendStatus: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      info: '',
      dragNodeData: {},
      submitColumns: [{
        label: '名称',
        prop: 'text',
      }, {
        label: '值',
        prop: 'value',
      }],
      formTable: {},
      times: 0,
      cycle: 100,
      nohup: false,
    };
  },
  mounted() {
  },
  watch: {
    // submitItem: {
    //   handler(newData) {
    //     const {dataSources} = newData;
    //     if (dataSources.length > 0) {
    //       const {key} = dataSources[0];
    //       const leftTree = this.$store.state.Engineering.leftStructure;
    //       for (const i in leftTree) {
    //         for (const j in leftTree[i].children) {
    //           for (const k in leftTree[i].children[j].children) {
    //             for (const m in leftTree[i].children[j].children[k].children) {
    //               for (const l in leftTree[i].children[j].children[k].children[m].children) {
    //                 if (key === leftTree[i].children[j].children[k].children[m].children[l].id) {
    //                   this.info = `${leftTree[i].text}-${leftTree[i].children[j].text}-${leftTree[i].children[j].children[k].children[m].children[l].text}`.replace(':', '');
    //                   this.dragNodeData = cloneDeep(leftTree[i].children[j].children[k].children[m].children[l]);
    //                   this.dragNodeData.children.forEach((signal, index) => {
    //                     if (signal.text.indexOf('#TIME') > -1) {
    //                       this.dragNodeData.children.splice(index, 1);
    //                     }
    //                   });
    //                   break;
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //       this.setSendConfig();
    //     } else {
    //       this.info = '';
    //       this.dragNodeData = {};
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    dataSources: {
      handler(newData) {
        const dataSources = newData;
        if (dataSources.length > 0) {
          const { key } = dataSources[0];
          const leftTree = this.$store.state.Engineering.leftStructure;
          for (const i in leftTree) {
            for (const j in leftTree[i].children) {
              for (const k in leftTree[i].children[j].children) {
                for (const m in leftTree[i].children[j].children[k].children) {
                  for (const l in leftTree[i].children[j].children[k].children[m].children) {
                    for (const n in leftTree[i].children[j].children[k].children[m].children[l].children) {
                      if (key === leftTree[i].children[j].children[k].children[m].children[l].children[n].id) {
                        this.info = `${leftTree[i].text}-${leftTree[i].children[j].text}-${leftTree[i].children[j].children[k].children[m].children[l].children[n].text}`.replace(':', '');
                        this.dragNodeData = cloneDeep(leftTree[i].children[j].children[k].children[m].children[l].children[n]);
                        const indexList = [];
                        this.dragNodeData.children.forEach((signal, index) => {
                          if (signal.text.indexOf('#TRIGGER') > -1 || signal.text.indexOf('#TIME') > -1) {
                            indexList.push(index);
                          }
                          // if (signal.text.indexOf('#TIME') > -1) {
                          //   this.dragNodeData.children.splice(index, 1);
                          // }
                          signal.byteOrder = signal.min;
                        });
                        for (let deleteIndex = indexList.length - 1; deleteIndex >= 0; deleteIndex -= 1) {
                          this.dragNodeData.children.splice(indexList[deleteIndex], 1);
                        } // 0317更新对于TRIGGER量的支持
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
          this.setSendConfig();
          // -----
          // this.saveConfig();
          // this.getValue();
          this.getValue();
        } else {
          this.info = '';
          this.dragNodeData = {};
        }
      },
      deep: true,
      immediate: true,
    },
    syncKey() {
      this.getValue();
    },
  },
  computed: {
    ...mapState('Engineering', ['componentStyleInfoArray', 'dragTreeNodeType']),
    ...mapGetters('Engineering', ['activedPanelData', 'getCurCmpStatus']),
    curPanelId() {
      return this.$store.state.Engineering.panelId;
    },
    dataSources() {
      return this.submitItem.dataSources;
    },
    syncKey() {
      return this.$store.state.Engineering.cmpSyncKey;
    },
  },
  methods: {
    ...mapMutations('Engineering', ['clickComponent', 'addSubmitCmp', 'deleteComponent', 'setAnchorPointId', 'setAnchorKeyWord', 'setControlSyncKey']),
    ...mapActions('Engineering', ['setSubmitValue', 'sendSubmitMsg', 'deleteCpt', 'stopSendMsg', 'saveSendConfig', 'getSendConfig', 'getSendValue']),
    clickSubmitCmp(index) {
      this.clickComponent({ componentName: 'submitCmp', cmpIndex: index, cmpType: 'submitCmp' });
    },
    // 向发送组件中添加信息
    dragToSubmitCmp(event, item, componentIndex) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      const { id, dtype, text } = dragNode;
      this.addSubmitCmp({
        id, dtype, text, componentIndex,
      });
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === 6) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },

    setSendConfig() {
      this.getSendConfig(this.submitIndex)
        .then((res) => {
          if (res === undefined) {
            this.cycle = 100;
            this.times = 0;
            this.nohup = false;
          } else {
            this.cycle = res.cycle;
            this.times = res.times;
            this.nohup = res.nohup;
            const nameArray = [];
            const valueArray = [];
            res.data.split('/').map((item) => {
              const arr = item.split('#');
              nameArray.push(arr[0]);
              valueArray.push(arr[1]);
            });
            for (let i = 0; i < nameArray.length; i += 1) {
              this.dragNodeData.children.map((item) => {
                if (item.text === nameArray[i]) {
                  item.byteOrder = valueArray[i];
                }
              });
            }
          }
        });
    },

    // 发送
    async handleSubmit(caller) {
      if (caller === 1 && this.nohup !== true) {
        return;
      }
      console.log(this.dragNodeData);
      const data = [];
      const configData = [];
      const messageKey = this.dragNodeData.id;
      const projectId = this.$store.state.Engineering.projectId;
      const keyList = [];
      // 0307由curPanelStatus改为curProjectStatus
      // if (this.$store.state.Engineering.curPanelStatus) {
      if (this.$store.state.Engineering.curProjectStatus) {
        this.dragNodeData.children.map((item) => {
          keyList.push(item.id);
          data.push({
            name: item.id,
            value: this.to10(`${item.byteOrder}`),
          });
          configData.push({
            name: item.text,
            value: this.to10(`${item.byteOrder}`),
          });
        });
        const sendResult = await this.sendSubmitMsg({
          data,
          index: this.submitIndex,
          times: this.times,
          cycle: this.cycle,
          nohup: this.nohup,
        });
        const saveResult = await this.saveSendConfig({
          configData,
          projectId,
          messageKey,
          index: this.submitIndex,
          times: this.times,
          cycle: this.cycle,
          nohup: this.nohup,
        });
        if (sendResult === true) {
          if (saveResult === true) {
            this.$message({
              message: '发送成功,当前配置已保存',
              type: 'success',
            });
          } else {
            console.log('发送配置保存失败', saveResult);
            this.$message({
              message: '发送成功，配置未保存',
              type: 'info',
            });
          }
          this.setControlSyncKey(keyList);
        } else {
          console.log('发送失败', sendResult);
          this.$message({
            message: '发送失败',
            type: 'error',
          });
        }
      } else {
        this.$message({
          message: '面板尚未启动',
          type: 'info',
        });
      }
    },
    async stopSend() {
      // 0307由curPanelStatus改为curProjectStatus
      // if (this.$store.state.Engineering.curPanelStatus) {
      if (this.$store.state.Engineering.curProjectStatus) {
        const data = this.dragNodeData.children.map(item => ({
          name: item.id,
          value: this.to10(`${item.byteOrder}`),
        }));
        const result = await this.stopSendMsg({
          data,
          index: this.submitIndex,
          times: this.times,
          cycle: this.cycle,
          nohup: this.nohup,
        });
        if (result) {
          this.$message({
            message: '停止发送数据',
            type: 'success',
          });
        } else {
          this.$message({
            message: '停止失败',
            type: 'error',
          });
        }
      } else {
        this.$message({
          message: '请点击开始 ',
          type: 'error',
        });
      }
    },
    handleCmp(command, component, index) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      switch (command) {
        case 'delete':
          this.deleteCpt({
            index,
          });
          break;
        default:
          break;
      }
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    // 限制输入最大最小值
    inputCheck(input, max, min) {
      const num = this.to10(input);
      console.log(num, '|', max, '|', min);
      if (num >= min && num <= max) {
        return input;
      } else if (num < min) {
        return min;
      }
      return max;
    },
    // 进制转换（10）
    to10(num) {
      if (num.indexOf('0x') === 0 || num.indexOf('0X') === 0) {
        return parseInt(num, 16);
      } else if (num.indexOf('0') === 0) {
        return parseInt(num, 8);
      }
      return num;
    },
    // 拖入数据后马上保存当前发送组件的配置信息
    // 在界面初始化时有报错现象，map undefined，待测试
    async saveConfig() {
      const configData = [];
      const messageKey = this.dragNodeData.id;
      const projectId = this.$store.state.Engineering.projectId;
      this.dragNodeData.children.map((item) => {
        configData.push({
          name: item.text,
          value: this.to10(`${item.byteOrder}`),
        });
      });
      // console.log('保存的数据↓');
      // console.log(configData);
      // console.log('保存的数据↑');
      const saveResult = await this.saveSendConfig({
        configData,
        projectId,
        messageKey,
        index: this.submitIndex,
        times: this.times,
        cycle: this.cycle,
        nohup: this.nohup,
      });
      if (saveResult === false) {
        console.log('发送配置保存失败', saveResult);
      }
    },
    // 获取发送信号的值
    getValue() {
      const dataSourceId = this.dragNodeData.id;
      this.getSendValue(dataSourceId)
        .then((res) => {
          // console.log('读取的数据↓');
          // console.log(res);
          // console.log('读取的数据↑');
          for (let i = 0; i < res.length; i += 1) {
            for (let j = 0; j < this.dragNodeData.children.length; j += 1) {
              if (res[i].signalId === this.dragNodeData.children[j].id) {
                this.dragNodeData.children[j].byteOrder = res[i].value;
                break;
              }
            }
          }
          this.saveConfig();
        }).catch((err) => {
          this.saveConfig();
        });
    },
  },
}
;
</script>

<style lang="scss">
  .submit-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .submit {
      border: dashed 1px #eee;
      padding: 10px;
      flex: 1;
      min-width: 100%;
      position: relative;

      .cmp-handle {
        position: absolute;
        top: 0;
        right: 0;

        .el-input__icon {
          line-height: 25px;
        }
      }

      &:hover {
        animation: 1s shadowChange infinite;
      }

      @keyframes shadowChange {
        0% {
          box-shadow: 0px 0px 2px #eee;
        }
        50% {
          box-shadow: 0px 0px 2px #aaa;
        }
        100% {
          box-shadow: 0px 0px 2px #eee;
        }
      }

      .title-content {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin: 20px 0;
      }
    }
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    width: 50%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/SubmitCmp.vue